import styled from 'styled-components';

export const DOSSIER_RESPONSIVE_MAX_WIDTH_PX = 768;

export const dossierResponsiveMediaQuery = `(max-width: ${DOSSIER_RESPONSIVE_MAX_WIDTH_PX}px)`;

export const $Page = styled.div<{ $hasBulkAction?: boolean }>`
  width: 100%;
  min-width: 0;
  max-width: 1400px;
  margin: 0 auto;
  box-sizing: border-box;
  padding-bottom: ${({ $hasBulkAction }) => ($hasBulkAction ? '5.5rem' : '0')};

  @media ${dossierResponsiveMediaQuery} {
    padding-bottom: ${({ $hasBulkAction }) => ($hasBulkAction ? '7rem' : '0')};
  }
`;

/** Défilement horizontal lorsque le tableau est plus large que l'écran (vue desktop). */
export const $DossierTableScrollArea = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  margin-top: 0.25rem;
`;

export const $PanelInner = styled.div`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;
